"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import v from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  v,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.884 13.246a.68.68 0 0 0 .965-.104.69.69 0 0 0-.104-.966l-3.708-2.978v-5.11a.69.69 0 0 0-.688-.688h-2.466a.69.69 0 0 0-.687.688v2.025l-2.74-2.203a.685.685 0 0 0-.858 0l-10.34 8.265a.687.687 0 1 0 .859 1.072l1.496-1.196v7.3c0 .683.554 1.237 1.237 1.237H9.8c.683 0 1.237-.555 1.237-1.238v-3.713h1.925v3.713c0 .683.555 1.238 1.238 1.238h4.95c.684 0 1.238-.555 1.238-1.238v-7.305zm-2.872-2.305-1.093-.878a.69.69 0 0 1-.256-.537V4.774H16.57v2.772a.684.684 0 0 1-1.117.535l-3.429-2.756-7.036 5.627v8.26h4.675V15.5c0-.683.554-1.238 1.237-1.238h2.2c.684 0 1.238.555 1.238 1.238v3.713h4.675V10.94Z",
        clipRule: "evenodd"
      }
    )
  }
), a = e(t);
export {
  a as House,
  a as default
};
